<div class="saveSearch">
  <rask-action-button negative (click)="saveSearchParams()" icon="far fa-save">
    {{ 'JUSTERA_LEVERANSPLAN_SPARA_SOKNING' | translate }}
  </rask-action-button>

  @if (show) {
    <div class="outer-popup-container">
      <div class="arrow-up">
      </div>
      <div class="popup-container">
        <rask-input label="{{ 'JUSTERA_LEVERANSPLAN_ANGE_NAMN' | translate }}" [(ngModel)]="model.namn"
        [required]="true"></rask-input>
        <div class="row buttons">
          <rask-button aid="buttonSpara" color="primary" (click)="trySave()">{{ 'DEFAULT_BUTTON_LABEL_SPARA' |
          translate }}</rask-button>
          <rask-button aid="buttonAvbryt" color="secondary" (click)="abort()">{{ 'DEFAULT_BUTTON_LABEL_AVBRYT'
          | translate }}</rask-button>
        </div>
        <div class="row">
          @if (errors) {
            <div class="feedback-panel">
              @for (error of errors; track error) {
                <small class="text-danger">{{error}}</small>
              }
            </div>
          }
        </div>
      </div>
    </div>
  }
</div>

@if (sokningar && sokningar.length > 0) {
  <rask-tabs [noActiveTab]="true" [wrap]="true" [size]="2" [closable]="true" closeIcon="far fa-trash-alt" closeIconColor="error"
    (onCloseTab)="confirmDeleteSparadSokning($event)"
    layout="child"
    aid="sokningar">
    @for (sokning of sokningar; track sokning) {
      <rask-tab
        [label]="sokning.namn"
        (onTabSelected)="setSokning(sokning)">
      </rask-tab>
    }
  </rask-tabs>
}
